<button    
    class="button" 
    [class.primary]="mode === 'primary' || mode === 'primary-text'"
    [class.secondary]="mode === 'secondary'"
    [class.help]="color === 'help'"
    [class.text]="mode === 'text'"
    [class.primary-text]="mode === 'primary-text'"
    [class.round]="mode === 'round'"
    [class.gray]="color === 'gray'"
    [class.tertiary]="mode === 'tertiary'"
    [class.disabled]="disabled">
        <mat-icon *ngIf="icon != '' " class="position-svg button-icon margin-right-xxxs">{{icon}}</mat-icon>
    {{label}}
</button>


